export default __webpack_public_path__ + "static/media/IMG-2733.cdd122b5.jpg";